import { useNavigate } from "react-router-dom";
import { ExternalLink } from "lucide-react";
import type { MatchAction, MatchCard } from "@hub/shared";
import { Button, Modal } from "@/ui";
import { MatchDetail } from "./MatchDetail";

/** The detail as a modal (from lists); the same component also renders at /matches/:matchId. */
export function MatchModal({ card, initialAction, onClose }: { card: MatchCard | null; initialAction?: MatchAction | null; onClose: () => void }) {
  const navigate = useNavigate();
  return (
    <Modal
      open={Boolean(card)}
      onClose={onClose}
      size="lg"
      title={
        card ? (
          <span className="u-row">
            <span>{card.display.title}</span>
            <Button size="sm" variant="ghost" icon={<ExternalLink size={13} />} onClick={() => navigate(`/matches/${card.matchId}`)}>
              Open page
            </Button>
          </span>
        ) : (
          ""
        )
      }
    >
      {card && <MatchDetail card={card} initialAction={initialAction ?? null} onClose={onClose} />}
    </Modal>
  );
}
